export const assetEditPage = {
  buttons: {
    save: '儲存',
  },
  title: '資料尋找',
}
